const routes = [
  {
    path: '',
    component: () => import('@/views/provider/periodEnd/PeriodEndWrapper.vue'),
    children: [
      {
        path: '/provider/periodEnd',
        name: 'PeriodEnd',
        component: () => import('@/views/provider/periodEnd/PeriodEnd.vue'),
      },
      {
        path: '/provider/visitRegistry/validateVisit',
        name: 'ValidateVisit',
        component: () =>
          import('@/views/provider/visitRegistry/VisitValidation.vue'),
      },
    ],
  },
];

export default routes;
